<ng-container *transloco="let t; prefix: 'multipleAddresses'">
  <!-- HEADER -->
  <div class="header-wrapper">
    <page-header
      [title]="t('title')"
      [icon]="['fas', 'home']"
      hasClose="true"
      (pageClose)="close()"
      shadowOnScroll
    ></page-header>
    <page-description>
      <p>
        {{ t('description') }}
      </p>
    </page-description>
  </div>

  <!-- CONTENT -->
  <div class="content-wrapper push-footer-down">
    <form
      #multipleAddressForm="ngForm"
      [formGroup]="addressesForm"
      [scrollToErrors]="multipleAddressForm"
      (ngSubmit)="submit()"
    >
      <multiple-address formControlName="address" [addressChoices]="addressChoices$ | async">
      </multiple-address>
    </form>
  </div>

  <!-- FOOTER -->
  <div class="footer-wrapper not-fixed shadow">
    <page-footer
      [primary]="{ label: t('useAddressBtn'), arrow: 'right' }"
      [primLoading]="isLoading$ | async"
      (primaryClicked)="multipleAddressForm.onSubmit()"
      [secondary]="{ label: t('cancelBtn'), arrow: 'left' }"
      (secondaryClicked)="close()"
      [valid]="addressesForm.touched && addressesForm.valid"
    ></page-footer>
  </div>
</ng-container>
